export const invoiceColumnNames = {
  ISSUED_DATE: 'issued_date',
  INVOICE_NUMBER: 'invoice_number',
  AMOUNT: 'amount',
  STATUS: 'status',
  ICON: 'icon',
} as const;

export type InvoiceColumnTypes =
  typeof invoiceColumnNames[keyof typeof invoiceColumnNames];
